import { useMemo, useState, useEffect } from "react";
import { Box } from "@mui/material";
import SubAbaCorretorFiltro from "../../Filtros/SubAbaCorretorFiltro";
import TabelaCorretores from "./TabelaCorretores";
import {
  getCorretores,
  updateCorretor,
  createCorretorJustificativa,
  getCorretoresCv,
  createCorretor,
  getImobiliarias,
  deleteCorretor,
} from "../../AssistenteVendasGestaoEndPoints";
import ModalEdicaoCorretor from "../../Modals/ModalEdicaoCorretor";
import ModalCadastroCorretor from "../../Modals/ModalCadastroCorretor";
import ModalExclusaoCorretor from "../../Modals/ModalExclusaoCorretor";
import { jwtDecode } from "jwt-decode";
import { getReadonlyFlag } from "../../../../../utils/getRoleToken";

const CorretorAba = ({
  imobiliariasDisponiveis = [],
  regioesDisponiveis = [],
  onContactClick = () => {},
}) => {

  const [clienteId, setClienteId] = useState(null);
  const [usuarioNome, setUsuarioNome] = useState("");
  const [usuarioId, setUsuarioId] = useState(null);
  const [corretoresBase, setCorretoresBase] = useState([]);
  const [corretoresFiltrados, setCorretoresFiltrados] = useState(corretoresBase);
  const [loading, setLoading] = useState(false);
  const [modalEdicaoAberto, setModalEdicaoAberto] = useState(false);
  const [corretorSelecionado, setCorretorSelecionado] = useState(null);
  const [salvandoCorretor, setSalvandoCorretor] = useState(false);
  const [edicaoSuccess, setEdicaoSuccess] = useState(false);
  const [edicaoError, setEdicaoError] = useState("");
  const [modalCadastroOpen, setModalCadastroOpen] = useState(false);
  const [cadastroLoading, setCadastroLoading] = useState(false);
  const [corretoresCv, setCorretoresCv] = useState([]);
  const [cadastroEmAndamento, setCadastroEmAndamento] = useState(new Set());
  const [cadastroSucesso, setCadastroSucesso] = useState(new Set());
  const [cadastroError, setCadastroError] = useState("");
  const [imobiliariasPorCorretor, setImobiliariasPorCorretor] = useState({});
  const [imobiliariasLookup, setImobiliariasLookup] = useState(new Map());
  const [modalExclusaoOpen, setModalExclusaoOpen] = useState(false);
  const [corretorParaExcluir, setCorretorParaExcluir] = useState(null);
  const [excluindoCorretor, setExcluindoCorretor] = useState(false);
  const [exclusaoSuccess, setExclusaoSuccess] = useState(false);
  const [exclusaoError, setExclusaoError] = useState("");
  const podeEditar = getReadonlyFlag() !== true;

  const [nomeFilter, setNomeFilter] = useState("");
  const [telefoneFilter, setTelefoneFilter] = useState("");
  const [imobiliariaFilter, setImobiliariaFilter] = useState("");
  const [regiaoFilter, setRegiaoFilter] = useState("");
  const sanitizeNumber = (value) => (value || "").replace(/\D/g, "");
  const normalizeId = (value) => {
    if (value == null) return null;
    const digits = String(value).replace(/\D/g, "");
    if (!digits) return null;
    return String(Number(digits));
  };

  const extractImobiliariaIds = (corretor) => {
    const ids = [];
    const pushId = (raw) => {
      const parsed = normalizeId(raw);
      if (parsed) ids.push(parsed);
    };

    pushId(corretor?.idImobiliaria);
    pushId(corretor?.id_imobiliaria);
    pushId(corretor?.idImobiliariaCorretor);

    const rawList = [
      corretor?.idsImobiliarias,
      corretor?.ids_imobiliarias,
      corretor?.idsImobiliaria,
      corretor?.ids_imobiliaria,
    ];

    rawList.forEach((raw) => {
      if (Array.isArray(raw)) {
        raw.forEach(pushId);
      } else if (typeof raw === "string") {
        raw
          .split("|")
          .map((item) => item.trim())
          .filter(Boolean)
          .forEach(pushId);
      }
    });

    if (Array.isArray(corretor?.imobiliarias)) {
      corretor.imobiliarias.forEach((item) => {
        pushId(item?.idImobiliaria ?? item?.id ?? item?.id_imobiliaria);
      });
    }

    return Array.from(new Set(ids));
  };

  const buildImobiliariasLookup = (lista) => {
    const map = new Map();
    (lista || []).forEach((imobiliaria) => {
      const id = normalizeId(
        imobiliaria?.idImobiliaria ?? imobiliaria?.id ?? imobiliaria?.id_imobiliaria
      );
      if (!id) return;
      const nome =
        imobiliaria?.nomeImobiliaria ||
        imobiliaria?.nome ||
        imobiliaria?.imobiliaria ||
        "";
      if (nome) map.set(id, String(nome));
    });
    return map;
  };

  const buildImobiliariasPorCorretor = (corretores, imobiliariasLookup) => {
    const map = {};
    (corretores || []).forEach((corretor) => {
      const idCorretor =
        corretor?.idCorretor ?? corretor?.id ?? corretor?.id_corretor ?? null;
      if (!idCorretor) return;
      const ids = extractImobiliariaIds(corretor);
      const nomes = ids
        .map((id) => imobiliariasLookup.get(id))
        .filter((item) => typeof item === "string" && item.trim());
      map[String(idCorretor)] = Array.from(new Set(nomes));
    });
    return map;
  };

  const extrairMensagemErro = (error) => {
    const resposta = error?.response?.data;

    if (resposta) {
      if (typeof resposta === "string") {
        const conteudoEntreColchetes = resposta.match(/\[\s*([\s\S]*?)\s*\]/);
        if (conteudoEntreColchetes?.[1]?.trim()) {
          return conteudoEntreColchetes[1].trim();
        }
        if (resposta.trim()) return resposta.trim();
      }

      if (typeof resposta === "object") {
        const camposPossiveis = ["message", "mensagem", "error"];
        for (const campo of camposPossiveis) {
          const valorCampo = resposta[campo];
          if (typeof valorCampo === "string" && valorCampo.trim()) {
            return valorCampo.trim();
          }
        }
      }
    }

    if (typeof error?.message === "string" && error.message.trim()) {
      return error.message.trim();
    }

    return "";
  };

  const filtrarCorretores = (listaBase = corretoresBase) => {
    const normalize = (value) => (value || "").toString().toLowerCase();
    const sanitizePhone = (value) => (value || "").toString().replace(/\D/g, "");
    const telefoneBusca = sanitizePhone(telefoneFilter);

    return listaBase.filter((corretor) => {
      const nomeMatch = nomeFilter
        ? normalize(corretor.nome).includes(normalize(nomeFilter))
        : true;

      const telefonesConcatenados = `${sanitizePhone(corretor.telefone)}${sanitizePhone(corretor.celular)}`;
      const telefoneMatch = telefoneFilter
        ? telefonesConcatenados.includes(telefoneBusca)
        : true;

      const imobiliariaMatch = imobiliariaFilter
        ? normalize(corretor.imobiliaria).includes(normalize(imobiliariaFilter))
        : true;

      const regiaoMatch = regiaoFilter
        ? normalize(corretor.regiao).includes(normalize(regiaoFilter))
        : true;

      return nomeMatch && telefoneMatch && imobiliariaMatch && regiaoMatch;
    });
  };

  const fetchCorretores = async (idClienteParam) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('jwtToken');
      if (!token) return;

      const decodedToken = jwtDecode(token);
      const idCliente = idClienteParam ?? decodedToken.id_cliente;

      setClienteId(idCliente);
      setUsuarioNome(decodedToken.nome || decodedToken.nomeUsuario || "Usuario");
      setUsuarioId(decodedToken.id_usuario || decodedToken.idUsuario || null);

      const dados = await getCorretores(idCliente);

      const corretoresMapeados = (dados || []).map((corretor, idx) => {
        const telefoneSanitizado = sanitizeNumber(
          corretor.telefone || corretor.celular || ""
        );
        const chaveBase =
          corretor.idCorretor ||
          telefoneSanitizado ||
          `${corretor.nomeCorretor || "corretor"}-${idx}`;

        return {
          uniqueKey: String(chaveBase),
          matchKey: String(chaveBase),
          idCorretor: corretor.idCorretor,
          nome: corretor.nomeCorretor,
          telefone: corretor.telefone,
          celular: corretor.celular,
          imobiliaria: corretor.nomeImobiliarias,
          regiao: corretor.nomeRegioes,
          idClienteAipim: corretor.idClienteAipim,
        };
      });

      setCorretoresBase(corretoresMapeados);
      setCorretoresFiltrados(filtrarCorretores(corretoresMapeados));
    } catch (error) {
      console.error('Erro ao carregar corretores:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCorretores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleApplyFilters = () => {
    setLoading(true);
    setTimeout(() => {
      setCorretoresFiltrados(filtrarCorretores());
      setLoading(false);
    }, 500);
  };

  const handleClearFilters = () => {
    setNomeFilter("");
    setTelefoneFilter("");
    setImobiliariaFilter("");
    setRegiaoFilter("");
    setLoading(true);
    setTimeout(() => {
      setCorretoresFiltrados(corretoresBase);
      setLoading(false);
    }, 500);
  };

  const imobiliariasDisponiveisMemo = useMemo(() => {
    const todasImobiliarias = corretoresBase.flatMap((corretor) =>
      (corretor.imobiliaria || "")
        .split("|")
        .map((item) => item.trim())
        .filter(Boolean)
    );

    return Array.from(new Set(todasImobiliarias));
  }, [corretoresBase]);

  const regioesDisponiveisMemo = useMemo(() => {
    const todasRegioes = corretoresBase.flatMap((corretor) =>
      (corretor.regiao || "")
        .split("|")
        .map((item) => item.trim())
        .filter(Boolean)
    );

    return Array.from(new Set(todasRegioes));
  }, [corretoresBase]);

  const handleOpenEdicao = (corretor) => {
    if (!podeEditar) return;
    setCorretorSelecionado(corretor);
    setEdicaoError("");
    setEdicaoSuccess(false);
    setModalEdicaoAberto(true);
  };

  const handleCloseEdicao = () => {
    setModalEdicaoAberto(false);
    setCorretorSelecionado(null);
    setEdicaoError("");
    setEdicaoSuccess(false);
  };

  const handleConfirmarEdicao = async (payload) => {
    if (!clienteId || !corretorSelecionado) return;

    setSalvandoCorretor(true);
    setEdicaoError("");
    setEdicaoSuccess(false);

    try {
      await updateCorretor({
        idCliente: clienteId,
        idCorretor: corretorSelecionado.idCorretor,
        novoNome: payload.novoNome,
        novoTelefone: payload.novoTelefone,
        novoCelular: payload.novoCelular,
      });

      const telefoneAnterior = sanitizeNumber(corretorSelecionado.telefone || "");
      const celularAnterior = sanitizeNumber(corretorSelecionado.celular || "");

      await registrarJustificativaCorretorEdicao({
        nomeAnterior: corretorSelecionado.nome,
        nomeAtual: payload.novoNome,
        telefoneAnterior,
        telefoneAtual: payload.novoTelefone,
        celularAnterior,
        celularAtual: payload.novoCelular,
      });

      await fetchCorretores(clienteId);
      setEdicaoSuccess(true);
    } catch (error) {
      console.error("Erro ao atualizar corretor:", error);
      const mensagemBackend = extrairMensagemErro(error);
      setEdicaoError(
        mensagemBackend ||
          "Nao foi possivel salvar as alteracoes. Tente novamente."
      );
    } finally {
      setSalvandoCorretor(false);
    }
  };

  const registrarJustificativaCorretorEdicao = async ({
    nomeAnterior,
    nomeAtual,
    telefoneAnterior,
    telefoneAtual,
    celularAnterior,
    celularAtual,
  }) => {
    const idClienteAipim = clienteId || corretorSelecionado?.idClienteAipim;
    if (!idClienteAipim || !usuarioId) return;

    const campos = [];
    const nomeMudou = (nomeAnterior || "").trim() !== (nomeAtual || "").trim();
    const telefoneAnteriorDigits = sanitizeNumber(telefoneAnterior);
    const telefoneAtualDigits = sanitizeNumber(telefoneAtual);
    const celularAnteriorDigits = sanitizeNumber(celularAnterior);
    const celularAtualDigits = sanitizeNumber(celularAtual);
    const telefoneMudou = telefoneAnteriorDigits !== telefoneAtualDigits;
    const celularMudou = celularAnteriorDigits !== celularAtualDigits;

    if (nomeMudou) {
      campos.push({
        label: "Nome",
        anterior: nomeAnterior || "-",
        novo: nomeAtual || "-",
      });
    }

    if (telefoneMudou) {
      campos.push({
        label: "Telefone",
        anterior: telefoneAnterior || "-",
        novo: telefoneAtual || "-",
      });
    }

    if (celularMudou) {
      campos.push({
        label: "Celular",
        anterior: celularAnterior || "-",
        novo: celularAtual || "-",
      });
    }

    if (campos.length === 0) return;

    const valorAnterior = campos
      .map((campo) => `${campo.label}: ${campo.anterior}`)
      .join(" | ");
    const valorNovo = campos
      .map((campo) => `${campo.label}: ${campo.novo}`)
      .join(" | ");
    const justificativaTexto = `${usuarioNome || "Usuario"} | [EDITOU] | Corretor: ${
      nomeAnterior || nomeAtual || "-"
    }`;

    try {
      await createCorretorJustificativa({
        idClienteAipim,
        idUsuario: usuarioId,
        valorAnterior,
        valorNovo,
        justificativa: justificativaTexto,
      });
    } catch (error) {
      console.error("Erro ao registrar justificativa do corretor:", error);
    }
  };

  const resolveUsuarioJustificativa = () => {
    if (usuarioId && usuarioNome) {
      return { idUsuario: usuarioId, nomeUsuario: usuarioNome };
    }

    const token = localStorage.getItem("jwtToken");
    if (!token) return { idUsuario: null, nomeUsuario: null };

    try {
      const decoded = jwtDecode(token);
      const idUsuario = decoded?.id_usuario ?? decoded?.idUsuario ?? null;
      const nomeUsuario = decoded?.nome ?? decoded?.nomeUsuario ?? "Usuario";

      if (!usuarioId && idUsuario) setUsuarioId(idUsuario);
      if (!usuarioNome && nomeUsuario) setUsuarioNome(nomeUsuario);

      return { idUsuario, nomeUsuario };
    } catch (error) {
      console.error("Erro ao decodificar usuario do JWT:", error);
      return { idUsuario: null, nomeUsuario: null };
    }
  };

  const registrarJustificativaCorretorCadastro = async (
    corretor,
    idClienteAipimParam,
    nomeImobiliariaCadastro = ""
  ) => {
    const idClienteAipim = idClienteAipimParam ?? clienteId;
    if (!idClienteAipim) return;

    const { idUsuario, nomeUsuario } = resolveUsuarioJustificativa();
    if (!idUsuario) return;

    const nomeCorretor = (
      corretor?.nome ||
      corretor?.nomeCorretor ||
      "-"
    ).toString();
    const telefone = corretor?.telefone || "";
    const celular = corretor?.celular || "";
    const imobiliaria = nomeImobiliariaCadastro || "-";

    const campos = [
      { label: "Nome", valor: nomeCorretor },
      { label: "Telefone", valor: telefone },
      { label: "Celular", valor: celular },
      { label: "Imobiliaria", valor: imobiliaria },
    ].filter((campo) => campo.valor && campo.valor.toString().trim());

    const valorNovo = campos.map((campo) => `${campo.label}: ${campo.valor}`).join(" | ");
    const justificativaTexto = `${nomeUsuario || "Usuario"} | [CADASTROU] | Corretor: ${nomeCorretor}`;

    try {
      await createCorretorJustificativa({
        idClienteAipim,
        idUsuario,
        valorAnterior: "",
        valorNovo,
        justificativa: justificativaTexto,
      });
    } catch (error) {
      console.error("Erro ao registrar justificativa de cadastro:", error);
    }
  };

  const corretoresCadastrados = useMemo(() => {
    return new Set(
      corretoresBase
        .map((corretor) => corretor.idCorretor)
        .filter((id) => id != null)
    );
  }, [corretoresBase]);

  const handleOpenCadastro = async () => {
    if (!podeEditar) return;
    setModalCadastroOpen(true);
    setCadastroLoading(true);
    setCadastroError("");
    setCadastroEmAndamento(new Set());
    setCadastroSucesso(new Set());
    setImobiliariasPorCorretor({});
    setImobiliariasLookup(new Map());

    try {
      let idCliente = clienteId;
      if (!idCliente) {
        const token = localStorage.getItem("jwtToken");
        if (token) {
          const decodedToken = jwtDecode(token);
          idCliente = decodedToken.id_cliente;
          setClienteId(idCliente);
        }
      }

      if (!idCliente) {
        setCorretoresCv([]);
        return;
      }

      const [dadosCorretoresCv, dadosImobiliarias] = await Promise.all([
        getCorretoresCv(idCliente),
        getImobiliarias(idCliente),
      ]);

      const lookup = buildImobiliariasLookup(dadosImobiliarias);
      const imobiliariasMap = buildImobiliariasPorCorretor(
        dadosCorretoresCv,
        lookup
      );

      setCorretoresCv(dadosCorretoresCv || []);
      setImobiliariasPorCorretor(imobiliariasMap);
      setImobiliariasLookup(lookup);
    } catch (error) {
      console.error("Erro ao carregar corretores CV:", error);
      setCorretoresCv([]);
      setImobiliariasPorCorretor({});
      setImobiliariasLookup(new Map());
    } finally {
      setCadastroLoading(false);
    }
  };

  const handleCloseCadastro = () => {
    setModalCadastroOpen(false);
  };

  const handleOpenExclusao = (corretor) => {
    if (!podeEditar) return;
    setCorretorParaExcluir(corretor);
    setExclusaoError("");
    setExclusaoSuccess(false);
    setModalExclusaoOpen(true);
  };

  const handleCloseExclusao = () => {
    if (excluindoCorretor) return;
    setModalExclusaoOpen(false);
    setCorretorParaExcluir(null);
    setExcluindoCorretor(false);
    setExclusaoError("");
    setExclusaoSuccess(false);
  };

  const registrarJustificativaCorretorExclusao = async (
    corretor,
    justificativaTexto,
    idClienteAipimParam
  ) => {
    const idClienteAipim = idClienteAipimParam ?? clienteId ?? corretor?.idClienteAipim;
    if (!idClienteAipim) return;

    const { idUsuario, nomeUsuario } = resolveUsuarioJustificativa();
    if (!idUsuario) return;

    const nomeCorretor = (corretor?.nome || "-").toString();
    const telefone = corretor?.telefone || "";
    const celular = corretor?.celular || "";

    const campos = [
      { label: "Nome", valor: nomeCorretor },
      { label: "Telefone", valor: telefone },
      { label: "Celular", valor: celular },
    ].filter((campo) => campo.valor && campo.valor.toString().trim());

    const valorAnterior = campos
      .map((campo) => `${campo.label}: ${campo.valor}`)
      .join(" | ");

    const justificativaFinal = `${nomeUsuario || "Usuario"} | [EXCLUIU] | Corretor: ${nomeCorretor} | ${justificativaTexto}`;

    try {
      await createCorretorJustificativa({
        idClienteAipim,
        idUsuario,
        valorAnterior,
        valorNovo: "",
        justificativa: justificativaFinal,
      });
    } catch (error) {
      console.error("Erro ao registrar justificativa de exclusão:", error);
    }
  };

  const handleConfirmarExclusao = async (justificativaTexto) => {
    let idCliente = clienteId;

    if (!idCliente) {
      const token = localStorage.getItem("jwtToken");
      if (token) {
        const decodedToken = jwtDecode(token);
        idCliente = decodedToken.id_cliente;
        setClienteId(idCliente);
      }
    }

    if (!idCliente || !corretorParaExcluir) return;

    setExcluindoCorretor(true);
    setExclusaoError("");
    setExclusaoSuccess(false);

    try {
      await deleteCorretor({
        idCliente,
        idCorretor: corretorParaExcluir.idCorretor,
        telefone: corretorParaExcluir.telefone || corretorParaExcluir.celular || "",
      });

      await registrarJustificativaCorretorExclusao(
        corretorParaExcluir,
        justificativaTexto,
        idCliente
      );

      await fetchCorretores(idCliente);
      setExclusaoSuccess(true);

      setTimeout(() => {
        handleCloseExclusao();
      }, 1200);
    } catch (error) {
      console.error("Erro ao excluir corretor:", error);
      const mensagemBackend = extrairMensagemErro(error);
      setExclusaoError(
        mensagemBackend ||
          "Nao foi possivel excluir o corretor. Tente novamente."
      );
    } finally {
      setExcluindoCorretor(false);
    }
  };

  const resolveCadastroIds = (corretor) => {
    const idCorretor =
      corretor?.idCorretor ?? corretor?.id ?? corretor?.id_corretor ?? null;
    const idImobiliaria =
      corretor?.idImobiliaria ??
      corretor?.id_imobiliaria ??
      corretor?.imobiliarias?.[0]?.idImobiliaria ??
      corretor?.idImobiliariaCorretor ??
      null;
    return { idCorretor, idImobiliaria };
  };

  const handleCadastrarCorretor = async (corretor) => {
    if (!podeEditar) return;
    setCadastroError("");
    let idCliente = clienteId;

    if (!idCliente) {
      const token = localStorage.getItem("jwtToken");
      if (token) {
        const decodedToken = jwtDecode(token);
        idCliente = decodedToken.id_cliente;
        setClienteId(idCliente);
      }
    }

    const { idCorretor, idImobiliaria } = resolveCadastroIds(corretor);

    if (!idCliente || !idCorretor || !idImobiliaria) {
      setCadastroError(
        "Nao foi possivel identificar o corretor ou a imobiliaria para cadastro."
      );
      return;
    }

    if (cadastroEmAndamento.has(idCorretor)) return;

    setCadastroEmAndamento((prev) => {
      const next = new Set(prev);
      next.add(idCorretor);
      return next;
    });

    try {
      await createCorretor({
        idCliente,
        idImobiliaria,
        idCorretor,
      });

      const nomeImobiliariaCadastro =
        imobiliariasLookup.get(normalizeId(idImobiliaria)) || "";

      await registrarJustificativaCorretorCadastro(
        corretor,
        idCliente,
        nomeImobiliariaCadastro
      );

      setCadastroSucesso((prev) => {
        const next = new Set(prev);
        next.add(idCorretor);
        return next;
      });

      await fetchCorretores(idCliente);
    } catch (error) {
      console.error("Erro ao cadastrar corretor:", error);
      const mensagemBackend = extrairMensagemErro(error);
      setCadastroError(
        mensagemBackend ||
          "Nao foi possivel cadastrar o corretor. Tente novamente."
      );
    } finally {
      setCadastroEmAndamento((prev) => {
        const next = new Set(prev);
        next.delete(idCorretor);
        return next;
      });
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SubAbaCorretorFiltro
        nomeFilter={nomeFilter}
        setNomeFilter={setNomeFilter}
        telefoneFilter={telefoneFilter}
        setTelefoneFilter={setTelefoneFilter}
        imobiliariaFilter={imobiliariaFilter}
        setImobiliariaFilter={setImobiliariaFilter}
        regiaoFilter={regiaoFilter}
        setRegiaoFilter={setRegiaoFilter}
        imobiliariasDisponiveis={imobiliariasDisponiveisMemo}
        regioesDisponiveis={regioesDisponiveisMemo}
        handleApplyFilters={handleApplyFilters}
        handleClearFilters={handleClearFilters}
        onOpenCadastro={handleOpenCadastro}
        showCadastro={podeEditar}
      />

      <TabelaCorretores
        corretores={corretoresFiltrados}
        loading={loading}
        onTelefoneClick={onContactClick}
        onEdit={handleOpenEdicao}
        onDelete={handleOpenExclusao}
        showEdit={podeEditar}
        showDelete={podeEditar}
      />

      <ModalCadastroCorretor
        open={modalCadastroOpen}
        onClose={handleCloseCadastro}
        loading={cadastroLoading}
        corretoresCv={corretoresCv}
        corretoresCadastrados={corretoresCadastrados}
        cadastroSucesso={cadastroSucesso}
        cadastroEmAndamento={cadastroEmAndamento}
        cadastroError={cadastroError}
        onCadastrar={handleCadastrarCorretor}
        imobiliariasPorCorretor={imobiliariasPorCorretor}
      />

      <ModalEdicaoCorretor
        open={modalEdicaoAberto}
        onClose={handleCloseEdicao}
        corretor={corretorSelecionado}
        usuarioNome={usuarioNome}
        saving={salvandoCorretor}
        success={edicaoSuccess}
        errorMessage={edicaoError}
        onConfirm={handleConfirmarEdicao}
      />

      <ModalExclusaoCorretor
        open={modalExclusaoOpen}
        onClose={handleCloseExclusao}
        corretor={corretorParaExcluir}
        usuarioNome={usuarioNome}
        loading={excluindoCorretor}
        success={exclusaoSuccess}
        errorMessage={exclusaoError}
        onConfirm={handleConfirmarExclusao}
      />
    </Box>
  );
};

export default CorretorAba;
